'use client';

import { useTranslation } from '@/features/i18n';
import { Link } from '@/ui/Link';
import { Button } from '@/ui/buttons/Button';
import { FaceFrownIcon } from '@heroicons/react/24/outline';
import { PlaybackErrorType } from '@vimond/services/play';

type Props = {
  error?: PlaybackErrorType;
};
export const VideoPlaybackErrorDisplay = ({ error }: Props) => {
  const { t } = useTranslation();
  return (
    <div className="bg-background grid min-h-full place-items-center px-6 py-24 text-center sm:py-32 lg:px-8">
      <div className="mb-6">
        <FaceFrownIcon className="text-primary mx-auto h-16 w-16" />
      </div>

      <p className="text-text-secondary text-base font-semibold">
        {t('something-went-wrong')}
      </p>
      <h1 className="text-primary mt-4 text-3xl font-bold tracking-tight sm:text-5xl">
        {t('unable-to-start-playback')}
      </h1>

      {error?.code ? (
        <p className="text-text-secondary mt-6 text-sm leading-6">
          {error.code} - {error.title}
        </p>
      ) : (
        <p className="text-text-secondary mt-6 text-base leading-7">
          {t('sorry-we-couldnt-play-the-video')}
        </p>
      )}
      <div className="mt-10 flex items-center justify-center gap-x-6">
        <Link href="/">
          <Button variant="primary">{t('go-back-home')}</Button>
        </Link>
      </div>
    </div>
  );
};
